// Block 3 client analytics: batched, fire-and-forget, dwell-time tracking.
import { API_BASE } from "./api";

let queue = [];
let timer = null;

function ctxHeaders() {
  return {
    "Content-Type": "application/json",
    "X-Platform": "web",
    "X-App-Version": "1.0.0",
    "X-Network": (navigator.connection && navigator.connection.effectiveType) || "unknown",
    "X-Language": localStorage.getItem("am_lang") || "English",
    ...(localStorage.getItem("am_token") ? { Authorization: `Bearer ${localStorage.getItem("am_token")}` } : {}),
  };
}

function flush(useBeacon = false) {
  if (!queue.length) return;
  const events = queue.splice(0, queue.length);
  const body = JSON.stringify({ events });
  const url = `${API_BASE}/events`;
  if (useBeacon && navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    return;
  }
  fetch(url, { method: "POST", headers: ctxHeaders(), body, credentials: "include", keepalive: true }).catch(() => {});
}

// Fixed event names only — never build dynamically.
export function track(name, props = {}) {
  queue.push({ name, props });
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => flush(false), 1500);
  if (queue.length >= 15) flush(false);
}

if (typeof window !== "undefined") {
  window.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(true); });
  window.addEventListener("pagehide", () => flush(true));
}

// Screen dwell tracker — call on mount, returns a cleanup that emits screen_viewed.
let sessionStarted = false;
export function startSession() {
  if (sessionStarted) return;
  sessionStarted = true;
  track("session_started", {});
}
